module.exports = __webpack_public_path__ + "img/businessCooperation-pc.5897948.webp";